import React from 'react'
import './Fireworks.scss'

export default function Fireworks() {
  return (
    <div className="pyro">
      <div className="before"></div>
      <div className="after"></div>
      </div>
  )
}
